import React from 'react';


// Internal Import
import instance from '../modules/axios';
import { ResponseLogin } from '../modules/types/login.type';
import { DialogStatusComponent, DialogStatusProps } from '../components/dialog';

// External Import
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { common } from "@mui/material/colors";
import LoadingButton from '@mui/lab/LoadingButton';
import { ReactSession } from 'react-client-session';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import {
    Box,
    Stack,
    Button,
    TextField,
    Typography,
} from '@mui/material';


const dot = [1, 2, 3];

export interface LoginProps { }
export const LoginScreen: React.FC<LoginProps> = () => {

    let navigate = useNavigate();
    let location = useLocation();


    const [loading, setLoading] = React.useState<boolean>(false);

    const [dialog, setDialog] = React.useState<DialogStatusProps>({
        open: false,
        message: "",
        screen: "login",
        status: 'error',
    });
    const handleCloseDialog = () => { setDialog({ ...dialog, open: false }); }

    const formik = useFormik({
        initialValues: {
            username: '',
            password: '',
            submit: null
        },
        validationSchema: Yup.object({
            username: Yup
                .string()
                .max(50)
                .required('Phone/Email is required'),
            password: Yup
                .string()
                .min(8, 'Password is too short - should be 8 chars minimum.')
                .required('Password is required.')
        }),
        onSubmit: async (values, helpers) => {
            let userFormData = new FormData();
            userFormData.append("username", values.username);
            userFormData.append("password", values.password);
            userFormData.append("platform", "website");
            userFormData.append("fcm_token", "");

            setLoading(true);

            handleApiLogin(userFormData);
        }
    });

    const handleApiLogin = async (data: FormData) => {
        try {
            const response: any = await instance.post('auth/login.php', data, {
                headers: { "Content-Type": "multipart/form-data" }
            });
            let dtResponse: any = response?.data;

            let dataResponse: ResponseLogin = {
                status: dtResponse?.status,
                message: dtResponse?.message,
                data: dtResponse?.data,
                token: dtResponse?.token,
            }

            if (dataResponse.status == 200) {
                if (dataResponse.data !== undefined) {
                    setLoading(false);

                    ReactSession.set("user_auth", true);
                    ReactSession.set("user_token", dataResponse.token);
                    ReactSession.set("user_data", dataResponse.data);

                    setDialog({
                        ...dialog,
                        open: true,
                        status: 'success',
                        message: dataResponse.message
                    });

                    setTimeout(() => {
                        handleCloseDialog();
                        navigate('/');
                    }, 1500);
                    return;
                }
            } else if (dataResponse.status > 400) {
                setLoading(false);
                setDialog({
                    ...dialog,
                    open: true,
                    status: 'error',
                    message: dataResponse.message
                });
                return;
            }

            setLoading(false);
            setDialog({
                ...dialog,
                open: true,
                status: 'error',
                message: 'Login Failed: Something problem, please try again!'
            });
        } catch (error) {
            setLoading(false);
            setDialog({
                ...dialog,
                open: true,
                status: 'error',
                message: 'Login Failed: Something problem, please try again!'
            });
        }

    }

    const goToLogin = () => {
        navigate('/');
    }


    return (
        <div>
            <Stack direction='row'>

                {/* // Contai Left // */}
                <Box
                    sx={{
                        width: '35vw',
                        margin: '2vw',
                        alignItems: 'center',
                        borderRadius: '1.5vw',
                        backgroundSize: 'cover',
                        justifyContent: 'center',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        display: { xs: 'none', md: 'none', lg: 'flex' },
                        backgroundImage: 'url(./assets/images/interior-house2.jpg)'
                    }}
                >
                    <Box
                        sx={{
                            flex: '1',
                            height: '100%',
                            display: 'flex',
                            borderRadius: '1.5vw',
                            flexDirection: 'column',
                            backgroundColor: 'rgba(0, 0, 0, 0.3)'
                        }}
                    >
                        <Box style={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-evenly',
                        }}>
                            <Typography
                                variant="h2"
                                color={common.white}
                                sx={{
                                    padding: 2,
                                    marginLeft: 4,
                                    marginRight: 4,
                                    fontFamily: 'Montserrat',
                                    backgroundColor: 'rgba(255, 255, 255, 0.25)'
                                }}
                            >
                                Discover and own the best properties by Ciputra
                            </Typography>
                            <Box sx={{ marginLeft: 4, marginRight: 4 }}>
                                <Typography
                                    variant="body1"
                                    color={common.white}
                                    sx={{
                                        textAlign: 'center',
                                        fontFamily: 'Montserrat',
                                    }}
                                >
                                    Building cities and building lives
                                </Typography>
                                <Box sx={{
                                    flex: 1,
                                    marginTop: 1,
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center'
                                }}>
                                    {dot.map((item, index) => {
                                        return (
                                            <Box key={index} sx={{
                                                width: 16,
                                                height: 2,
                                                marginLeft: 0.5,
                                                marginRight: 0.5,
                                                borderRadius: 1,
                                                backgroundColor: common.white
                                            }} />
                                        )
                                    })}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>

                {/* // Contain Right // */}
                <Box
                    sx={{
                        display: 'flex',
                        flex: '1 1 auto',
                        minHeight: '100vh',
                        alignItems: 'center',
                        justifyContent: 'center',
                        paddingTop: { xs: 6, md: 0, lg: 0 },
                        paddingLeft: { xs: 4, md: 0, lg: 0 },
                        paddingRight: { xs: 4, md: 0, lg: 0 },
                        paddingBottom: { xs: 6, md: 0, lg: 0 },
                    }}
                >
                    <Box sx={{ width: '100%', maxWidth: 550 }}>
                        <div>
                            <Stack spacing={1} sx={{ mb: 3 }}>
                                <Box sx={{ display: { xs: 'flex', md: 'flex', lg: 'none' } }}>
                                    <img
                                        alt="Logo Ciputra"
                                        src="/assets/logos/ciputra.png"
                                        style={{
                                            height: 18,
                                            marginBottom: 16,
                                            display: 'inline-block',
                                        }}
                                    />
                                </Box>
                                <Typography variant="h4">
                                    Hello! Welcome back.
                                </Typography>
                                <Typography color="text.secondary" variant="body2">
                                    To keep connected with us please login with your personal information.
                                    <br />
                                    Don&apos;t have an account?
                                    &nbsp;
                                    <Link
                                        to="/register"
                                        style={{
                                            color: '#008060',
                                            textDecoration: 'none',
                                        }}
                                    >
                                        Register
                                    </Link>
                                </Typography>
                            </Stack>
                            <form noValidate onSubmit={formik.handleSubmit}>
                                <Stack spacing={3}>
                                    <TextField
                                        fullWidth
                                        name="username"
                                        type="text"
                                        label="Phone/Email"
                                        placeholder='Your Phone/Email'
                                        onBlur={formik.handleBlur}
                                        value={formik.values.username}
                                        onChange={formik.handleChange}
                                        error={!!(formik.touched.username && formik.errors.username)}
                                        helperText={formik.touched.username && formik.errors.username}
                                    />
                                    <TextField
                                        fullWidth
                                        name="password"
                                        type="password"
                                        label="Password"
                                        onBlur={formik.handleBlur}
                                        placeholder='Your Password'
                                        onChange={formik.handleChange}
                                        value={formik.values.password}
                                        error={!!(formik.touched.password && formik.errors.password)}
                                        helperText={formik.touched.password && formik.errors.password}
                                    />
                                </Stack>
                                {formik.errors.submit && (
                                    <Typography
                                        color="error"
                                        sx={{ mt: 3 }}
                                        variant="body2"
                                    >
                                        {formik.errors.submit}
                                    </Typography>
                                )}
                                <LoadingButton
                                    fullWidth
                                    size="large"
                                    type="submit"
                                    sx={{ mt: 3 }}
                                    startIcon={<></>}
                                    loading={loading}
                                    disabled={loading}
                                    variant="contained"
                                    loadingPosition='start'
                                >
                                    {loading ? "Please wait..." : "Login"}
                                </LoadingButton>
                                <Button
                                    fullWidth
                                    size="large"
                                    sx={{ mt: 3 }}
                                    onClick={goToLogin}
                                >
                                    Skip Login
                                </Button>
                            </form>
                        </div>
                    </Box>
                </Box>
            </Stack>
            <DialogStatusComponent
                open={dialog.open}
                status={dialog.status}
                screen={dialog.screen}
                message={dialog.message}
                handleClose={handleCloseDialog}
            />
        </div>
    )
};